import NotFound from 'routes/NotFound/components/NotFound';

export default NotFound;
